module.exports = __webpack_public_path__ + "static/media/heart-b-filled.145d3ab0.svg";